<div class="w-full search-container d-flex fl-al-center fl-justify-between h-fit p-0">
  <div class="form-group form-main form-group-overrides width-100per mb-0">
    <div class="div-group width-100per">
      <mat-form-field
        appearance="fill"
        id="access-manager-matAutoComplete"
        matTooltipClass="add-member-tooltip"
        class="w-full"
        [ngClass]="{
          'white-background': isInputFocused,
          'temp-alignment': !isInputFocused,
          'bg-[#F5F5F5] border-[#C1C2C5]': disabled
        }"
      >
        <div matPrefix class="mr-2 matPrefix-search-icon flex-center">
          <img src="../../../../assets/images/search-blue.svg" width="20px" height="19px" />
        </div>

        <input
          #inputField
          type="text"
          matInput
          aria-label="Number"
          [disabled]="disabled"
          [formControl]="connectionUserFormControl"
          [matAutocomplete]="auto"
          [placeholder]="placeHolder"
          class="addMember global-input text-base font-sans font-normal text-[#53565B]"
          [ngClass]="{ 'text-[#53565B66]': disabled }"
          (input)="onItemSearch($event.target.value)"
          (focus)="onInputFocus()"
          (blur)="onInputBlur()"
        />

        <div *ngIf="connectionUserFormControl.value" matSuffix (click)="onClearInput()">
          <mat-icon class="close-input-icon mr-4">close</mat-icon>
        </div>

        <mat-autocomplete #auto="matAutocomplete" class="search-scroll-main template-Search">
          <div>
            <ng-container>
              <div class="width-100per">
                <div
                  class="app__tags--input py-1 px-4"
                  [ngClass]="{ 'bg-[#EBF0FA]': isTagInputShown, 'bg-white': !isTagInputShown }"
                  (click)="$event.stopPropagation()"
                >
                  @if(!isTagInputShown){
                  <div
                    class="app__attributes-dialog-title flex items-center text-center font-semibold text-[13px] text-[#25508E] hover:cursor-pointer gap-1"
                    (click)="isTagInputShown = true"
                  >
                    <span class="text-2xl">+</span> Add Custom tag
                  </div>
                  } @else {
                  <div>
                    <div class="relative w-full h-[40px] bg-white mb-1">
                      <div class="app__discovery--header--search--field w-full h-full">
                        <div class="app__centered-item w-full h-full px-1 py-1">
                          <input
                            class="w-full h-full border-none outline-none text-[12px] ml-2"
                            type="text"
                            maxlength="30"
                            placeholder="Custom Tag"
                            (input)="onCustomTagNameInputChange($event.target.value)"
                            (click)="$event.preventDefault(); $event.stopPropagation()"
                            (keydown)="handleKeyDown($event)"
                            (keyup)="$event.stopPropagation()"
                            (keypress)="$event.stopPropagation()"
                          />
                        </div>
                      </div>
                      <div class="flex">
                        <span
                          class="absolute right-[53px] top-1/2 transform -translate-y-1/2 text-[#5475C0] hover:cursor-pointer"
                          (click)="isTagInputShown = false; customTagName = ''"
                        >
                          <img src="assets/images/inbox/custom-close-icon.svg" />
                        </span>
                        <button
                          type="button"
                          class="absolute right-2 top-1/2 transform -translate-y-1/2"
                          (click)="addUserTag()"
                          [disabled]="customTagName.length === 0"
                          [class]="
                            customTagName.length === 0
                              ? 'app__btn--disabled w-fit px-2 py-[2px] mb-0 mt-0 rounded text-[12px]'
                              : 'app__btn--primary  w-fit px-2 py-[2px] mb-0 mt-0 rounded text-[12px]'
                          "
                        >
                          Add
                        </button>
                      </div>
                    </div>
                    @if(errorMessage){
                    <span class="text-red-500 text-[12px]"> {{ errorMessage }} </span>
                    }
                  </div>
                  }
                </div>

                <mat-option disabled class="h-fit" *ngIf="(processedData | filterList : connectionUserFormControl.value)?.length == 0">
                  <div class="flex gap-4 py-3 h-fit fl-al-center text-base font-medium">No search results found</div>
                </mat-option>

                <div *ngIf="(processedData | filterList : connectionUserFormControl.value)?.length != 0">
                  <div class="search-list-overflow">
                    <div>
                      <mat-option
                        class="search-list-box"
                        *ngFor="let item of processedData | filterList : connectionUserFormControl.value; let i = index"
                      >
                        <div class="d-flex fl-justify-between fl-al-center">
                          <div class="d-flex fl-al-center">
                            <mat-checkbox
                              type="checkbox"
                              class="checkbox-input custom-individual-checkBox relative"
                              [checked]="item.isSelected"
                              (change)="createVaultUserTag($event, item)"
                              (click)="$event.stopPropagation()"
                            >
                            </mat-checkbox>
                            <div>
                              <div class="text-sm font-normal font-sans color-[#18191C]">{{ item?.name }}</div>
                            </div>
                          </div>
                        </div>
                      </mat-option>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </div>
</div>
